import Vue from 'vue';
import dayjs from 'dayjs';

import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import 'dayjs/locale/ru';
import 'dayjs/locale/uk';

dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(utc);

export default function () {
  Object.defineProperties(Vue.prototype, {
    $dayjs: {
      get() {
        return dayjs;
      },
    },
  });
}
